export default __webpack_public_path__ + "static/media/surat-jalan-eksternal.1fc738b0.png";